import { c as _c } from "react/compiler-runtime";
import styles from "./UserPageStats.module.scss";
export function UserPageStatsTableHead() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <thead><tr><th /><th className="text-right !tw-text-[#93939f]">Total</th><th className="text-right !tw-text-[#93939f]">Memes</th><th className="text-right !tw-text-[#93939f]">NextGen</th><th className="text-right !tw-text-[#93939f]">Gradient</th><th className="text-right !tw-text-[#93939f]">Meme Lab</th></tr></thead>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function UserPageStatsTableHr(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <hr className="mb-1 mt-1 tw-border-[#93939f]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.span) {
    t1 = <tr><td colSpan={props.span} className={styles.collectedAccordionTableHr}>{t0}</td></tr>;
    $[1] = props.span;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}